import Vue from 'vue';

// 禁止输入空格
Vue.directive('trim', {
  inserted: el => {
    el.addEventListener('input', () => {
      let oInput = el.getElementsByTagName('input')[0];
      let val = oInput.value;
      oInput.value = val.trim();
    });
  },
});

// 元素拖拽
Vue.directive('drag', {
  // inserted表示一个元素，插入到DOM中会执行inserted函数，只触发一次
  inserted: function(el, { value }) {
    let oEl = el,
      oDom = el;
    let { selectClassName, dragClassName } = value;
    // 拖拽选中的元素
    if (selectClassName) {
      oEl = el.querySelector(selectClassName);
      oEl.className = oEl.className + ' no-selected';
      oEl.style.cursor = 'pointer';
    }

    // 实际拖拽移动的元素
    if (dragClassName) {
      oDom = el.querySelector(dragClassName);
    }

    oEl.onmousedown = e => {
      let disx = e.pageX - oDom.offsetLeft;
      let disy = e.pageY - oDom.offsetTop;
      document.onmousemove = e => {
        oDom.style.left = e.pageX - disx + 'px';
        oDom.style.top = e.pageY - disy + 'px';
      };
      document.onmouseup = () => (document.onmousemove = document.onmouseup = null);
    };
  },
});
